const numeroNatural = /^\d+$/;
const dinero = /^\d+(\.+(\d+)?)?$/;
const textoIngresadoEsDinero = /^\$?(\d+(?:[.,]\d{0,2})?)?$/ //Se usa dentro para strings en los formularios  
const caracteresEspeciales= /^[^<>=!@/\\]*$/;
const correoElectronico = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
const NumerosConGuiones = /^[\d-]+$/;
const esRangosGuiasConComa = /^[\d-,]+$/;
const validarRetencion = /^([0-9][0-9][0-9]-[0-9][0-9][0-9]-[0-9]+)$/;
const ceroALaIzquierda = /^(0[0-9])$/;


export function numerosNaturales(dato: string) {
    return numeroNatural.test(dato)
} 


export function esRangoGuiaConComa(dato:string){
    return esRangosGuiasConComa.test(dato)
}

export function tieneUnceroALaIzquierda(dato:string){
    return ceroALaIzquierda.test(dato)
}

export function esNumeroOGuion(dato: string) {
    return NumerosConGuiones.test(dato)
} 

export function esRetencion(dato: string){
    return validarRetencion.test(dato)
}

export const typeMoney = (dato: string) =>{
    if(dato === ""){
        return true
    }
    return dinero.test(dato)
}

//Para formulario con inputs tipo String donde validamos que solo lleven hasta 2 decimales 
export const esDinero = (dato: string) =>{
    if(dato === ""){
        return true
    }
    return textoIngresadoEsDinero.test(dato)
}

export const textValidate = (text: string) => {
    return caracteresEspeciales.test(text)
}

export const esEmailValido = (text: string) =>{
    return correoElectronico.test(text)
}









